import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#06038D',
        },
        secondary: {
            main: '#F87C56',
        },
        action: {
            active: '#838383',
        },
    },
    typography: {
        fontFamily: ['Montserrat'].join(','),
    },
});

export default theme;
